export enum TaskContactMethodNames {
  'Call' = 0,
  'Fax' = 1,
  'Email' = 2,
  'Text' = 3,
  'Mail' = 4,
  'Manual' = 5,
}
